import React from "react";

interface SkeletonCardProps {
  isHired?: boolean;
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  isHired = false,
}) => {
  return (
    <div
      className="w-full min-h-16 flex items-center gap-3 px-3 py-1.5 rounded-xl transition-all duration-200 bg-transparent pointer-events-none"
      aria-hidden="true"
    >
      {/* Avatar Skeleton */}
      <div
        className={`relative shrink-0 ${isHired ? "border border-aera-greendark rounded-full p-0.5" : ""}`}
      >
        <div className={`${isHired ? "w-8.5 h-8.5" : "w-10 h-10"} rounded-full bg-aera-lightgray/50 animate-pulse`} />
      </div>

      {/* Content Skeleton */}
      <div className="block opacity-100 max-w-full flex-1 min-w-0">
        <div className="grid grid-cols-1 gap-2 justify-between items-center mb-0.5 min-w-[150px]">
          <div className="h-4 w-28 max-w-full bg-aera-lightgray/50 rounded animate-pulse" />
        </div>
        <div className="h-3 w-14 bg-aera-lightgray/50 rounded animate-pulse mb-1.5" />
        <div className="flex flex-wrap items-center gap-1">
          {!isHired && (
            <>
              <div className="h-3 w-12 bg-aera-lightgray/50 rounded animate-pulse" />
              <div className="h-3 w-10 bg-aera-lightgray/50 rounded animate-pulse" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
